import React from 'react'
import PropTypes from 'prop-types'

import { getPhoneValidState } from '../../../utils/validateFunctions'
import { ctaErrorAmoOffer } from '../../../apiRequests/callToAction'
import { ACTION_STATUSES } from '../../CtaAbstractSection'

import SectionContainer from '../../SectionContainer'
import InputIndexPage from '../../InputIndexPage'
import ButtonFilled from '../../ButtonFilled'
import ActionNotification from '../../ActionNotification'
import CtaAbstractForm from '../../CtaAbstractSection'

import SquareCheck from '../../../assets/svg/icon_chekSquare.svg'
import RedCheck from '../../../assets/svg/icon__redCheck.svg'

import componentData from '../../../pages-data/common/commonData'

import styles from './styles.module.styl'


export default class SectionPhoneCallRequest extends CtaAbstractForm {

  constructor(props) {
    super(props)
  }

  validateInput = phone => {
    return getPhoneValidState(phone)
  }

  actionRequest = async phone => {

    await this.props.ctaAction(phone)

    // если при успешном запросе на заявку в последующем gtm-событии поступит ответ с любым кодом, кроме 200,
    // то он не отловится в экземпляре CtaAbstractForm (т.к. CtaAbstractForm
    // отлавливает только NetError-ошибки с кодами 500+), поэтому ошибка отлавливается здесь.

    // Если же при gtm-событии возникнет ошибка сервера 500+, то запрос на создание заявки будет
    // считаться неудавшимся, что неверно, т.к. запрос на создание заявки удался - не удался лишь
    // запрос gtm-события, который также будет отловлен здесь для предотвращения ложной сигнализации
    // о неудавшемся создании заявки.

    try {
      this.props.gtmAction()
    }
    catch (error) {
      console.log(error)
    }
  }

  ctaErrorAmoOffer = () => {
    return ctaErrorAmoOffer('phone', this.state.inputValue)
  }

  closeNotification = () => {

    if (this.props.closeModal) {
      this.props.closeModal()
    }
    else {
      this.hideNotification()
    }

  }

  render() {
    const sectionData = this.props.data

    // Стили при горизонтальном расположении контента формы:
    const horizontal = this.props.horizontal ? styles.horizontal : ''

    const renderForm = () => (
      <div>
        <div
          className={`
          ${styles.phoneCallRequest__formContainer}
          ${horizontal}
          ${this.props.formContainerClassName ? this.props.formContainerClassName : ''}
        `}>

          <InputIndexPage
            inputAriaLablel={sectionData.inputAriaLablel || 'Телефон'}
            className={`
            ${styles.phoneCallRequest__input}
            ${this.props.inputClassName ? this.props.inputClassName : ''}
          `}
            placeholder={sectionData.placeholder || componentData.phoneMask}
            invalidMessage={this.state.inputInvalidMessage}
            value={this.state.inputValue}
            changeHandler={this.inputChangeHandler}
            extraProps={{
              type: 'tel',
              maxLength: 18,
              name: 'phone'
            }}
          />

          <ButtonFilled
            colorType={`${this.props.buttonStyles && this.props.buttonStyles.buttonColorType
              ? this.props.buttonStyles.buttonColorType 
              : "blue"}`}
            className={`
            ${styles.phoneCallRequest__button}
            ${this.props.buttonStyles && this.props.buttonStyles.buttonClassName 
              ? this.props.buttonStyles.buttonClassName 
              : ''}`}
            handler={() => this.actionButtonHandler('phone')}
            disabled={this.state.actionStatus === ACTION_STATUSES.SENDING}
          >
            {sectionData.button}
          </ButtonFilled>
        </div>

        {/*Согласие на обработку данных*/}
        <div className=
               {`${styles.phoneCallRequest__agreementWrapper}
               ${this.props.agreementClassName ? this.props.agreementClassName : ''} 
               ${horizontal}`}
        >
          {
            this.state.agreementStatus
              ? <SquareCheck onClick={() => this.setState({
                  agreementStatus: false,
                })
                }/>
              : <RedCheck onClick={() => this.setState({
                agreementStatus: true,
                agreementWarning: false
              })}/>
          }

          <p className={styles.phoneCallRequest__agreement}>
            {componentData.ctaRequestAgreement}
          </p>

          <div className={`
            ${styles.phoneCallRequest__agreementWarning}
            ${this.state.agreementWarning ? '' : styles.hide}
            ${horizontal}
          `}>
            {componentData.requireAgreementWarning}
          </div>

        </div>
      </div>
    )

    return (
      <SectionContainer
        className={`
          ${styles.phoneCallRequestContainer}
          ${horizontal} 
          ${this.props.sectionContainerClassName ? this.props.sectionContainerClassName : ''}
          `}>
        <section
          className={`
          ${styles.phoneCallRequest}
          ${horizontal} 
          ${this.props.sectionClassName ? this.props.sectionClassName : ''}
         `}>

          <div
            id={sectionData.id}
            className={styles.phoneCallRequest__anchor}
          />

          <h3
            className={`
              ${styles.phoneCallRequest__header}
              ${horizontal}
              ${this.props.headerClassName ? this.props.headerClassName : ''}
          `}>
            {sectionData.header}
          </h3>

          {
            sectionData.content &&
            <p
              className={`
              ${styles.phoneCallRequest__text}
              ${this.props.textClassName ? this.props.textClassName : ''}
           `}>
              {sectionData.content}
            </p>
          }


          {
            this.state.actionStatus === ACTION_STATUSES.NOT_SEND || this.state.actionStatus === ACTION_STATUSES.SENDING
              ? renderForm()
              : (
                <ActionNotification
                  className={styles.phoneCallRequest__ActionNotification}
                  isError={this.state.actionStatus === ACTION_STATUSES.FAIL}
                  closeHandler={this.closeNotification}
                  text={
                    this.state.actionStatus === ACTION_STATUSES.SUCCESS
                      ? sectionData.notification || 'Мы вам позвоним!'
                      : sectionData.invalidMessage || 'Ошибка на сервере! Пожалуйста, позвоните нам: <a href=\'tel:88005002138\'>8 800 500-21-38</a> (звонок бесплатный)'
                  }
                />
              )
          }
        </section>
      </SectionContainer>
    )
  }

}

SectionPhoneCallRequest.propTypes = {
  data: PropTypes.object.isRequired, // текст (заголовок, описание и т.п.)
  ctaAction: PropTypes.func.isRequired, // основной обработчик cta-формы
  gtmAction: PropTypes.func, // функция для генерации google-tag-manager-события
  closeModal: PropTypes.func, //обработчик закрытия модалки при закрытии уведомления

  sectionContainerClassName: PropTypes.string, // доп.класс для стилизации
  sectionClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  textClassName: PropTypes.string,
  formContainerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  // Стили кнопки - объект со свойствами: buttonClassName - класс и
  // buttonColorType - props для компонента <ButtonFilled/> "colorType"
  buttonStyles: PropTypes.object,
  agreementClassName: PropTypes.string,

  horizontal: PropTypes.bool // горизонтальное расположение контента в секции
}
